import { createSlice } from "@reduxjs/toolkit";
import { getClauseTransverse, getRootTransverse } from "./notes-documents-thunk";
import { updateClause, updateClauseNode, updateDocuments } from "./utils";

const initialState = {
	expandedDocuments: false,
	documents: {
		precedence: [],
	},
};
const notesDocumentsSlice = createSlice({
	name: "notesDocuments",
	initialState,
	reducers: {
		setExpandedDocuments: (state, { payload }) => ({ ...state, expandedDocuments: payload }),
		setDocuments: (state, { payload }) => ({
			...state,
			...updateDocuments({ payload }, state),
		}),
		setOpenDocumentNode: (state, { payload }) => ({
			...state,
			documents: {
				...state.documents,
				contents: state.documents.contents.map(
					(md) =>
						(md.id === payload && {
							...md,
							open: !md.open,
						}) ||
						md
				),
			},
		}),
		setUpdateContentNode: (state, { payload }) => {
			const { documentId, clauseId, propName, value } = payload;
			return {
				...state,
				documents: {
					...state.documents,
					contents: state.documents.contents.map(
						(md) =>
							(md.id === documentId && {
								...md,
								subClauses: md.subClauses.map(
									(clause) =>
										(clause.id === clauseId && { ...clause, open: !clause.open }) || {
											...clause,
											...((Array.isArray(clause.subClauses) && {
												subClauses: updateClauseNode(clause.subClauses, clauseId, {
													propName,
													value,
												}),
											}) ||
												{}),
										}
								),
							}) ||
							md
					),
				},
			};
		},
	},
	extraReducers: (builder) => {
		builder.addCase(getRootTransverse.fulfilled, (state, action) => {
			const { documentId } = action.meta.arg;
			return {
				...state,
				documents: {
					...state.documents,
					contents: state.documents.contents.map(
						(md) => (md.id === documentId && { ...md, subClauses: action.payload }) || md
					),
				},
			};
		});
		builder.addCase(getClauseTransverse.fulfilled, (state, action) => {
			const { documentId, clauseId } = action.meta.arg;
			return {
				...state,
				documents: {
					...state.documents,
					contents: state.documents.contents.map(
						(md) =>
							(md.id === documentId && {
								...md,
								subClauses: updateClause(md.subClauses, action.payload, clauseId),
							}) ||
							md
					),
				},
			};
		});
	},
});
export { getRootTransverse, getClauseTransverse };
export const { setExpandedDocuments, setDocuments, setOpenDocumentNode, setUpdateContentNode } =
	notesDocumentsSlice.actions;
export default notesDocumentsSlice.reducer;
